import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import React from 'react';
type ImageItemProps = {
  imageUrl?: string;
  width: number | undefined;
  height: number | undefined;
  children: React.ReactNode;
};
const ImageItem: React.FC<ImageItemProps> = t0 => {
  const $ = _c(9);
  const {
    imageUrl,
    width,
    height,
    children
  } = t0;
  const t1 = imageUrl ?? "";
  const t2 = width ?? 10;
  const t3 = height ?? 10;
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = <div><Image className="mt-2" src={t1} width={t2} height={t3} alt="logo" /></div>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children) {
    t5 = <div className="w-full">{children}</div>;
    $[4] = children;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <div className="flex flex-row gap-6">{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export default ImageItem;